import { MembershipTypeDto, MembershipTypeRecordStatus } from '@/apiClient';
import { usePrivate } from '@/components/private';
import { TMembershipType } from '@/model/configuration';
import useSWR from 'swr';

export const getMembershipTypeByOrgIdCachedKey = (orgId: number) => [
  `api/MembershipType/GetMembershipTypesByOrganisationId/${orgId}`,
];

export const useGetMembershipTypeByOrgId = () => {
  const { membershipTypeApi, selectedOrganisationId } = usePrivate();

  const path =
    (selectedOrganisationId &&
      membershipTypeApi &&
      getMembershipTypeByOrgIdCachedKey(selectedOrganisationId)) ||
    null;

  const { data, isLoading, mutate } = useSWR(
    path,
    () =>
      membershipTypeApi?.apiMembershipTypeGetMembershipTypesByOrganisationIdOrganisationIdGet(
        selectedOrganisationId!,
      ),
  );

  const parseMembershipTypeToFormValues = (
    data: MembershipTypeDto[],
  ): TMembershipType[] => {
    return data.map((m) => {
      return {
        id: m.membershipTypeId!.toString(),
        membershipTypeId: m.membershipTypeId,
        name: m.name || '',
        recordStatus: m.recordStatus || MembershipTypeRecordStatus.Inactive,
        order: m.order || 1,
        annualPrice:
          m.membershipTypeDurations?.find(
            (duration) =>
              duration.fee?.organisationId === selectedOrganisationId,
          )?.fee?.rate || 0,
      };
    });
  };

  return {
    memberships: data?.data || [],
    isFetching: isLoading,
    parseMembershipTypeToFormValues,
    refetch: mutate,
  };
};
